import { VehicleTypeFilter } from 'generated/graphql'

export const VEHICLE_TYPES: { value: VehicleTypeFilter; label: string }[] = [
  { value: VehicleTypeFilter.All, label: 'All vehicle types' },
  { value: VehicleTypeFilter.Hgv, label: 'HGV' },
  { value: VehicleTypeFilter.NonHgv, label: 'Non-HGV' },
]
